// extracted by mini-css-extract-plugin
export default {"socialContainer":"cl3y7eupl","holder":"ci42n1sjd","text":"ciu1mk1z5","icon":"ca3amy0n9"};